import type { FC } from "react";
import { Doc } from "sharedb/lib/client";

import { WorksheetType } from "../../../../shared/types/worksheet";

import { GroupNotAssignedBanner } from "./GroupNotAssignedBanner";
import { OlderSubmissionAssessedBanner } from "./OlderSubmissionAssessedBanner";
import { StudentEditingUnsubmittableBanner } from "./StudentEditingUnsubmittableBanner";
import { StudentsNotInGroupBanner } from "./StudentsNotInGroupBanner";
import { SubmissionStatusBanner } from "./SubmissionStatusBanner";
import { SubmissionsDifferFromResponsesBanner } from "./SubmissionsDifferFromResponsesBanner";
import { UnassessablePageSubmissionsBanner } from "./UnassessablePageSubmissionsBanner";

import { EmptyPageBanner } from "components/materials/page/banners/EmptyPageBanner";
import { GroupSubmittedByBanner } from "components/materials/page/banners/GroupSubmittedByBanner";
import { InstructorEditingStudentDraftBanner } from "components/materials/page/banners/InstructorEditingStudentDraftBanner";
import { InstructorLateSubmissionBanner } from "components/materials/page/banners/InstructorLateSubmissionBanner";
import { LateSubmissionAvailableBanner } from "components/materials/page/banners/LateSubmissionsAvailableBanner";
import { PageReleasedBanner } from "components/materials/page/banners/PageReleasedBanner";
import { StudentLateSubmissionBanner } from "components/materials/page/banners/StudentLateSubmissionBanner";
import { type PageTabVariant } from "providers/DocViewProvider";

type PageBannersProps = {
  pageId: string;
  doc?: Doc<WorksheetType>;
  selectedTabVariant?: PageTabVariant;
};

export const PageBanners: FC<PageBannersProps> = ({ pageId, doc, selectedTabVariant }) => {
  // Child banners self-gate; empty:hidden collapses the wrapper when none render.
  return (
    <div className="mb-2 flex w-full max-w-[--page-default-max-width] flex-col gap-4 empty:hidden">
      <InstructorEditingStudentDraftBanner
        pageId={pageId}
        selectedTabVariant={selectedTabVariant}
      />
      <SubmissionsDifferFromResponsesBanner
        pageId={pageId}
        selectedTabVariant={selectedTabVariant}
      />
      <PageReleasedBanner pageId={pageId} selectedTabVariant={selectedTabVariant} />
      <InstructorLateSubmissionBanner pageId={pageId} selectedTabVariant={selectedTabVariant} />
      <StudentLateSubmissionBanner pageId={pageId} selectedTabVariant={selectedTabVariant} />
      <GroupSubmittedByBanner pageId={pageId} />
      <StudentEditingUnsubmittableBanner pageId={pageId} selectedTabVariant={selectedTabVariant} />
      <LateSubmissionAvailableBanner pageId={pageId} selectedTabVariant={selectedTabVariant} />
      <GroupNotAssignedBanner pageId={pageId} />
      <StudentsNotInGroupBanner pageId={pageId} />
      <EmptyPageBanner doc={doc} />
      <UnassessablePageSubmissionsBanner pageId={pageId} />
      <SubmissionStatusBanner doc={doc} pageId={pageId} />
      <OlderSubmissionAssessedBanner pageId={pageId} />
    </div>
  );
};
